<template>
  <div v-if="this.$store.state.project && this.$store.state.project.kanbanColumns">
    <!-- Topbar de filtros -->
    <div class="kanban-topbar">
      <v-text-field 
        v-model="filters.description" 
        label="Filtrar por descripción" 
        outlined 
        dense 
        @input="applyFilters" 
        style="color: black; background-color: white;"
      />
      <v-text-field 
        v-model="filters.writer" 
        label="nombre.apellido" 
        outlined 
        dense 
        @input="applyFilters" 
        style="color: black; background-color: white;"
      />
      <v-select
        v-if="this.$store.state.subprojects.length > 0"
        v-model="filters.subproject"
        :items="this.$store.state.subprojects.map(e => e.name)"
        label="Filtrar por subproyecto"
        outlined
        dense
        @change="applyFilters"
        style="color: black; background-color: white;"
        clearable
      />
      <v-btn 
        color="primary" 
        outlined 
        @click="clearFilters"
        :disabled="!hasActiveFilters"
      >
        <v-icon left>mdi-filter-remove</v-icon>
        Limpiar filtros
      </v-btn>
    </div>
    
    <!-- Kanban -->
    <div class="kanban-board custom-scrollbar" v-if="kanban.columns">

      <!-- Columnas -->
      <div v-for="column,column_index in kanban.columns" 
        class="kanban-column"
        @dragover.prevent="onDragOver"
        @drop="onDrop(column_index)"
        :key="column_index">

        <h2 style="user-select: none;">{{ column.name }}</h2>

        <!-- Contenedor -->
        <div class="kanban-element-container custom-scrollbar" v-if="column.elements">

          <!-- Tareas -->
          <div v-for="element, element_index in filteredElements(column.elements)" 
            class="kanban-element" 
            draggable="true"
            @dragstart="onDragStart(element_index, column_index)"
            @dragend="onDragEnd"
            @drop="onDrop(column_index, element_index)"
            @dragover.prevent
            @click="showElement(element)"
            :key="element_index">

            <v-chip> {{ projectName(element.project) }}</v-chip>
            <span v-if="element">{{ element.description.replace("Compromiso:", "").replace('compromiso:', '')}}</span>
            <v-chip v-if="element.puntaje">
              <v-icon left small color="yellow">mdi-star</v-icon>
              {{ element.puntaje }}
            </v-chip>
          </div>

        </div>

      </div>
    </div>
  
    <!-- Tarjeta trello -->
    <TrelloCard v-if="showCard" 
      :card="selectedCard" 
      :dialog="showCard" 
      @update:dialog="closeCard"
    />
  </div>
</template>

<script>
class Kanban {
  constructor() {
    this.columns = [];
  }
  
  addColumn(column){
    this.columns.push(column);
  }
}

class Column {
  constructor(name, elements) {
    this.name = name;
    this.elements = elements;
  }
  
  addElement(element) {
    this.elements.push(new Element(element));
  }
}

class Element {
  constructor(element) {
    this.content = element;
  }
}

import TrelloCard from "./trello/TrelloCard.vue";
import api from '@/api.js';
export default {
  name: "KanBan",
  components: {
    TrelloCard
  },
  computed: {
    showCard(){
      return this.$store.state.showTrelloCard;
    },
    selectedCard(){
      return this.$store.state.selectedCard;
    },
    hasActiveFilters() {
      return this.filters.description !== '' || 
             this.filters.writer !== '' || 
             this.filters.subproject !== '';
    }
  },
  data(){
    return {
      kanban: {},
      elements: [],  // Elementos de la base de datos
      columnsNames: [], // Columnas de la base de datos
      draggedElement: {},  // Elemento que se está arrastrando
      draggedColumnIndex: {}, // Índice de la columna de origen del arrastre
      filters: {
        description: '',
        writer: '',
        subproject: '', // uid
      }
    }
  },
  methods: {
    projectName(id){
      if(id === this.$route.params.projectId){
        return 'Global';
      }

      return this.$store.state.subprojects.find(p => p._id === id)?.name;
    },
    // Métodos de arrastre
    onDragStart(element_index, column_index){
      // Obtener el elemento que se está arrastrando
      this.draggedElement = this.kanban.columns[column_index].elements[element_index];

      // Guardar el índice de la columna de origen
      this.draggedColumnIndex = column_index;

      // console.log(`onDragStart - ${element_index} - ${column_index}`);
    },
    onDragEnd(){
      // console.log('onDragEnd');
      this.draggedElement = null;
      this.draggedColumnIndex = null;
    },
    // Métodos de área de soltar
    onDragOver(event){  //?
      // Permite el comportamiento de drop
      event.preventDefault();
      // // console.log('onDragOver');
    },
    async onDrop(column_index, drop_element_index){
      // Evita que se lance si no hay un elemento arrastrado
      if(this.draggedElement !== null){
        // Elimina el elemento de la columna original
        this.kanban.columns[this.draggedColumnIndex].elements = this.kanban.columns[
          this.draggedColumnIndex
        ].elements.filter((el) => el !== this.draggedElement);

        // Agrega el elemento arrastrado a la columna destino
        // this.kanban.columns[column_index].elements.push(this.draggedElement);

        // Actualizar el estado del elemento según la columna destino
        this.draggedElement.state = this.kanban.columns[column_index].name;

        this.updateElement(this.draggedElement);

        // Insertar el elemento en la nueva posición
        if (this.draggedColumnIndex === column_index) {
          // Si es la misma columna, insertarlo en la posición correcta
          this.kanban.columns[column_index].elements.splice(drop_element_index, 0, this.draggedElement);
        } else {
          // Si es diferente columna, agregarlo al final
          this.kanban.columns[column_index].elements.push(this.draggedElement);
        }

        // Emitir evento de actualización del elemento a través de WebSocket
        this.$socket.emit('event_update_element', {
          room: this.$route.params.projectId,
          user: localStorage.getItem('email'), // O cualquier información del usuario que necesites
          element: this.draggedElement
        });

        // Si el elemento llega a la última columna, actualizar el sprint
        if (column_index === this.kanban.columns.length - 1) {
          await this.updateSprint(this.draggedElement);
        } 
        // Si el elemento retrocede desde la última columna, actualizar el sprint en modo 'atrás'
        else if (this.draggedColumnIndex === this.kanban.columns.length - 1) {
          await this.updateSprint(this.draggedElement, 'atras');
        }

        // Resetea los valores de arrastrado
        this.draggedElement = null;
        this.draggedColumnIndex = null;
      }
    },
    // Api
    async getElements(){
      try{
        const response = await api.get(
          `/api/element/project/${this.$route.params.projectId}/kanban`
        )

        this.elements = response.data;

        // console.log({elementos: this.elements});

      }catch(e){
        console.error(e);
      }
    },
    async updateElement(element){
      try {
        await api.put(`/api/element/update/${element._id}`, element);
      } catch (error) {
        console.log(error);
      }
    },
    async updateSprint(element, mode='adelante') {
      console.log('Se llegó a la ultima columna -> Actualizando sprint...');
      try {
        // Obtener el sprint actual del elemento
        if(!element.sprint){
          console.log('Elemento sin sprint');
          return;
        }
        const sprintId = element.sprint;
        const response = await api.get(`/api/sprint/${sprintId}`);
        const sprint = response.data;
        console.log('Sprint actual:', sprint);

        // Calcular los puntos restantes
        const alpha = mode === 'adelante' ? 1 : -1;
        const initialPoints = sprint.history[sprint.history.length - 1].pointsLeft;
        const pointsLeft = initialPoints - element.puntaje * alpha;
        console.log('Puntos antes: ', initialPoints, 'Puntos después: ', pointsLeft);

        // Crear un nuevo registro en el historial del sprint
        const newHistoryEntry = {
          date: new Date(),
          pointsLeft: pointsLeft,
        };

        // Actualizar el sprint con el nuevo historial
        sprint.history.push(newHistoryEntry);
        console.log('nuevo historial', sprint.history);
        const responsex = await api.put(`/api/sprint/${sprintId}`, sprint);
        console.log(responsex);

        console.log('Sprint actualizado:', sprint);
      } catch (error) {
        console.error('Error al actualizar el sprint:', error);
      }
    },
    initSocket(){
      this.$socket.on('element_updated', (payload) => {
        const updatedElement = payload.element;
        if(payload.user === localStorage.getItem('email')){
          return;
        }
        console.log('Llego nuevo elemento', updatedElement);
        console.log({ kanbanBefore: this.kanban });

        // Remover el elemento de su columna original
        let elementMoved = false;
        for (let column of this.kanban.columns) {
          const index = column.elements.findIndex(el => el._id === updatedElement._id);
          if (index !== -1) {
            column.elements.splice(index, 1);
            elementMoved = true;
            break;
          }
        }

        // Si el elemento ha sido removido, añadirlo a la nueva columna
        if (elementMoved) {
          const targetColumn = this.kanban.columns.find(col => col.name === updatedElement.state);
          if (targetColumn) {
            targetColumn.elements.push(updatedElement);
          }
        }

        console.log({ kanbanAfter: this.kanban });
      });

    },
    showElement(element){
      // this.selectedCard = element;
      this.$store.commit('setSelectedCard', element);
      this.$store.commit('switchTrelloCard');
      console.log('Mostrando elemento', element);
    },
    closeCard() {
      this.$store.commit('switchTrelloCard');
    },
    clearFilters() {
      this.filters.description = '';
      this.filters.writer = '';
      this.filters.subproject = '';
      this.applyFilters();
    },
    applyFilters() {
      this.setKanban();
    },
    isElementVisible(element) {
      const matchesDescription = this.filters.description === '' || element.description.toLowerCase().includes(this.filters.description.toLowerCase());
      const matchesWriter = this.filters.writer === '' || element.writer.toLowerCase().includes(this.filters.writer.toLowerCase());
      return matchesDescription && matchesWriter;
    },
    filteredElements(elements) {
      return elements.filter(element => {
        const matchesDescription = this.filters.description === '' || (element.description && element.description.toLowerCase().includes(this.filters.description.toLowerCase()));
        const matchesWriter = this.filters.writer === '' || (element.participants && element.participants.some(participant => participant.toLowerCase().includes(this.filters.writer.toLowerCase())));

        let matchesSubproject = false;
        let allProjects = [...this.$store.state.subprojects, this.$store.state.project];
        if(this.filters.subproject !== ''){
          matchesSubproject = allProjects.some(project => project.name === this.filters.subproject && element.project === project._id);
        } else {
          matchesSubproject = true; // Si no hay filtro, todos los elementos coinciden
        }
        return matchesDescription && matchesWriter && matchesSubproject;
      });
    },
    setKanban(){
      this.columnsNames = this.$store.state.project?.kanbanColumns?.length > 0 ? this.$store.state.project.kanbanColumns : ['new', 'desarrollo', 'finalizado' ];
      this.kanban = new Kanban();

      // TODO: Mejorar la forma en que se asignan los elementos a las columnas -> recorrer elementos y asignarlos de inmediato a cada columna usando objeto['atributo']
      // Recorrer columnas
      for(let i = 0; i < this.columnsNames.length; i++){
        var elementsFiltered = [];
        // Recorrer elementos
        for(let j = 0; j < this.elements.length; j++){
          if(this.elements[j].state === this.columnsNames[i]){
            elementsFiltered.push(this.elements[j]);
          }
        }
        this.kanban.addColumn(new Column(this.columnsNames[i], elementsFiltered));
      }
    }
  },
  watch: {
    '$store.state.project': {
      handler(newProject) {
        if (newProject && newProject.kanbanColumns) {
          this.setKanban();
        }
      },
      deep: true
    }
  },
  async created(){
    // Obtener elementos (tareas)
    await this.getElements();
    this.initSocket();
    this.setKanban();
  }
}
</script>

<style scoped>
:root {
  --background-neutral-hovered: #091e4224;
  --background-neutral: #091e420f;
}

.custom-scrollbar {
  scrollbar-width: thin;
  -webkit-overflow-scrolling: touch;
  /* -webkit-transform: translate3d(0, 0, 0); */
  scrollbar-color: #323b36 #1c2015;
}

.kanban-board {
  background-color: trasparent;
  display: flex;
  gap: 20px;
  color: #b6c2cf;
  background-color: #eef1f4;
  justify-content: left;
  height: 100%;
  padding: 30px;
  overflow-x: auto;
  font-size: 14px;
  overflow-x: scroll;
  height: 90vh;
}

.kanban-board h2{
  color: #b6c2cf;
  text-align: center;
  font-size: 17px;
}

.kanban-column{
  background-color: #101204;
  border-radius: 12px;
  width: 272px;
  display: flex;
  flex-direction: column;
  height: 90%;
}

.kanban-element-container{
  overflow-x: hidden;
  overflow-y: auto;
}


.kanban-element {
  background-color: #22272b;
  margin: 10px;
  padding: 10px;
  border-radius: 5px;
  color: white;
  cursor: pointer;
  user-select: none;
}

.kanban-element:hover {
  outline: 1px solid white;
}

.kanban-element:active {
  outline: none;
  background-color: #8a4584;
}

.kanban-topbar {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin: 5px;
  gap: 10px;
}
</style>